import { KalkulatorFormComponent } from './kalkulator-form.component';
import EzresBontasModule from '../../../common/directives/ezresbontas/ezresbontas';
import AngularSliderModule from  'angularjs-slider'
export const KalkulatorFormModule = angular
	.module('kalkulatorForm', [EzresBontasModule, AngularSliderModule])
	.component('kalkulatorForm', KalkulatorFormComponent)
	.name;




// WEBPACK FOOTER //
// ../source/application/kalkulator/kalkulator-form/kalkulator-form.module.js